import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { GetLinkedCasesQuery } from './get-linked-cases.query';
import { GetLinkedCasesResult } from './get-linked-cases.result';

/**
 * Get linked cases use case.
 * Retrieves linked cases for a case.
 */
@Injectable({ providedIn: 'root' })
export class GetLinkedCasesUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(query: GetLinkedCasesQuery): Observable<GetLinkedCasesResult> {
    this._state.setLoadingLinkedCases(true);
    this._state.setErrorLinkedCases(null);

    return this._repository.getLinkedCases(query.caseId).pipe(
      tap((linkedCases) => {
        this._state.setLinkedCases(linkedCases);
        this._state.setLoadingLinkedCases(false);
      }),
      map((linkedCases) => ({ linkedCases })),
      catchError((error) => {
        this._state.setErrorLinkedCases(error.message || 'Failed to get linked cases');
        this._state.setLoadingLinkedCases(false);
        return throwError(() => error);
      })
    );
  }
}
